import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";
import { RESOURCES } from "./NavigationConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `/`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "login-alt",
    path: `/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "login-1",
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-1")
    ),
  },
  {
    key: "login-2",
    path: `${AUTH_PREFIX_PATH}/login-2`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-2")
    ),
  },
  {
    key: "register-1",
    path: `${AUTH_PREFIX_PATH}/register-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-1")
    ),
  },
  {
    key: "register-2",
    path: `${AUTH_PREFIX_PATH}/register-2`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-2")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
];

export const protectedRoutes = [
  // Set Password (for temporary password flow)
  {
    key: "set-password",
    path: `${AUTH_PREFIX_PATH}/set-password`,
    component: React.lazy(() =>
      import("views/auth-views/components/SetPasswordForm")
    ),
    meta: {
      blankLayout: true
    }
  },
  // Profile and Account routes
  {
    key: "profile",
    path: `${APP_PREFIX_PATH}/profile`,
    component: React.lazy(() => import("views/app-views/profile")),
  },
  {
    key: "change-password",
    path: `${APP_PREFIX_PATH}/change-password`,
    component: React.lazy(() => import("views/app-views/change-password")),
  },
  // Dashboard
  {
    key: "app-dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/kw/dashboard")),
    permission: { resource: RESOURCES.DASHBOARD, action: 'read' },
  },
  // Appointments / Bookings
  {
    key: "app-bookings",
    path: `${APP_PREFIX_PATH}/bookings`,
    component: React.lazy(() => import("views/app-views/kw/bookings")),
    permission: { resource: RESOURCES.BOOKINGS, action: 'read' },
  },
  // Calendar
  {
    key: "app-calendar",
    path: `${APP_PREFIX_PATH}/calendar`,
    component: React.lazy(() => import("views/app-views/kw/calendar")),
    permission: { resource: RESOURCES.BOOKINGS, action: 'read' },
  },
  // Customers
  {
    key: "app-customers",
    path: `${APP_PREFIX_PATH}/customers`,
    component: React.lazy(() => import("views/app-views/kw/customers")),
    permission: { resource: RESOURCES.CUSTOMERS, action: 'read' },
  },
  // Estimates / Quotes
  {
    key: "app-estimates",
    path: `${APP_PREFIX_PATH}/estimates`,
    component: React.lazy(() => import("views/app-views/kw/estimates")),
    permission: { resource: RESOURCES.ESTIMATES, action: 'read' },
  },
  // Invoices
  {
    key: "app-invoices",
    path: `${APP_PREFIX_PATH}/invoices`,
    component: React.lazy(() => import("views/app-views/kw/invoices")),
    permission: { resource: RESOURCES.INVOICES, action: 'read' },
  },
  // Payments
  {
    key: "app-payments",
    path: `${APP_PREFIX_PATH}/payments`,
    component: React.lazy(() => import("views/app-views/kw/payments")),
    permission: { resource: RESOURCES.PAYMENTS, action: 'read' },
  },
  // User Management
  {
    key: "app-users",
    path: `${APP_PREFIX_PATH}/admin/users`,
    component: React.lazy(() => import("views/app-views/kw/users")),
    permission: { resource: RESOURCES.USERS, action: 'read' },
  },
  // File Manager
  {
    key: "app-file-manager",
    path: `${APP_PREFIX_PATH}/admin/file-manager`,
    component: React.lazy(() => import("views/app-views/kw/file-manager")),
    permission: { resource: RESOURCES.DOCUMENTS, action: 'read' },
  },
  // Backup & Restore
  {
    key: "app-backups",
    path: `${APP_PREFIX_PATH}/admin/backups`,
    component: React.lazy(() => import("views/app-views/kw/backups")),
    adminOnly: true,
  },
];
